import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import RecordedLessonsTable from './RecordedLessonsTable';
const RecordedLessons = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Recorded Lessons' parent='Recorded Lessons'  />
      <Container fluid={true}>
        <Row>
          <RecordedLessonsTable  />
        </Row>
      </Container>
    </Fragment>
  );
};

export default RecordedLessons;
